'use client';

import { mq } from '@/lib/StyledComponents/mq';
import type { ImageBlockData } from '@/schema/cms/blocks/ImageBlockSchema';
import Image from 'next/image';
import Link from 'next/link';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  display: flex;
`;

const MailContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.main.primary};
  width: 100%;

  display: flex;
  justify-content: end;
`;

const PhoneContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.light.primary};
  width: 100%;

  display: flex;
  justify-content: start;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  max-width: 45rem;
  width: 100%;
  margin: 2.5rem 0;

  a {
    color: ${({ theme }) => theme.colors.text.dark};
    text-decoration: underline;
  }

  ${mq(null, 'tablet')} {
    margin: 1.5rem 0;

    img {
      height: 2rem;
      width: 2rem;
    }

    a {
      font-size: 0.813rem;
    }
  }
`;

type Props = {
  mail: {
    link: string;
    logo: ImageBlockData;
  };
  phoneNumber: {
    link: string;
    logo: ImageBlockData;
  };
};

export const PhoneAndMail = ({ mail, phoneNumber }: Props) => {
  return (
    <Container>
      <MailContainer>
        <Content>
          <Image
            src={mail.logo.url}
            alt={mail.logo.alt}
            width={48}
            height={48}
          />
          <Link href={`mailto:${mail.link}`}>{mail.link}</Link>
        </Content>
      </MailContainer>
      <PhoneContainer>
        <Content>
          <Image
            src={phoneNumber.logo.url}
            alt={phoneNumber.logo.alt}
            width={48}
            height={48}
          />
          <Link href={`tel:${phoneNumber.link}`}>{phoneNumber.link}</Link>
        </Content>
      </PhoneContainer>
    </Container>
  );
};
